var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"main-heading"},[_vm._v("Genres & Moods")]),_c('BaseContent',[_c('BaseSection',{attrs:{"padded":""}},[_c('GenreGridBlock',{attrs:{"genres":_vm.genres,"followed-genre-ids":_vm.followedGenreIds},on:{"toggle-follow":_vm.handleToggleFollow}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }